"use client";
import type React from "react";

export default function Layout({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}
